import * as React from "react";
import PropTypes from "prop-types";

import MuiButton from "@mui/material/Button";

function Button(props) {
  return <MuiButton {...props} />;
}

export const ButtonPropTypes = {
  variant: PropTypes.oneOf(["text", "outlined", "contained", "subAction"]),
  onClick: PropTypes.func,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  startIcon: PropTypes.any,
};

Button.propTypes = ButtonPropTypes;

export default Button;
